import { useMediaQuery } from '@mui/material';
import { RefObject, useEffect, useState } from 'react';

type TableStyle = {
  height: string;
  paddingBottom: number;
};

export const useDynamicTableHeight = (
  headerRef: RefObject<HTMLDivElement>,
  preferredWorkerAccordionRef: RefObject<HTMLDivElement>
) => {
  const isSmallScreenHeight = useMediaQuery('(max-height: 1200px)');
  const [tableStyle, setTableStyle] = useState<TableStyle>({
    height: '500px',
    paddingBottom: 5,
  });

  useEffect(() => {
    if (!isSmallScreenHeight && headerRef.current && preferredWorkerAccordionRef.current) {
      const newHeight = `calc(90vh - ${headerRef.current.offsetHeight + preferredWorkerAccordionRef.current.offsetHeight}px)`;

      setTableStyle({
        height: newHeight,
        paddingBottom: 0,
      });
    }
  }, [isSmallScreenHeight, headerRef.current, preferredWorkerAccordionRef.current]);

  return tableStyle;
};
